const nums = /\d+/g

/** parseIDs takes a given string and returns all
 * found Norad IDs, ignoring any whitespace separators.
 * Return value is an Array<Number>. */
export const parseIDs = (str = "") => (str.match(nums) || []).map((s) => +s)
